var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    display: 'inline-block',
    lineHeight: 0,
    padding: '24px',
    borderRadius: '4px',
    background: _vm.bgColor,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }